export enum ProjectResearchType {
  Qualitative = 1,
  Quantitative = 2
}
